<template>
  <div
      :ref="messageBoxRefId"
      style="padding:10px;"
      class="wrapper"
      @scroll="handleScroll"
  >
    <div
        v-if="messages && Array.isArray(messages)"
    >
      <div
          v-for="(aMessage, i) in messages"
          :key="`msg_${i}`"
      >
        <bubble :id="`bubble-user-${i}`"
                v-if="aMessage.prompt && aMessage._created_by === profile.userId"
                bubble-owner="user"
                :profile="profile"
                :message="aMessage.prompt"
        />
        <bubble :id="`bubble-user-${i}`"
                v-else-if="aMessage.prompt"
                bubble-owner="fam"
                :profile="profile"
                :message="aMessage.prompt"
        />


        <bubble :id="`bubble-user-${i}`"
                v-if="aMessage.response"
                :profile="profile"
                bubble-owner="iona"
                :message="aMessage.response"
                @is-thumb-up="handleIsThumbUp(aMessage, isThumbUp)"
        />

        <div
            v-if="aMessage.status && aMessage.status.state ? aMessage.status.state ==='PROCESSING' : false"
            style="text-align: center; color:#fcc727"
        >
          <thinking-dots />
        </div>
      </div>
    </div>
    <div v-else-if="bubblePresets && Array.isArray(bubblePresets)">
      <bubble
          v-for="(aPreset, i) in bubblePresets" :key="`bp_${i}`"
          :id="`bubble-preset-${i}`"
          style="cursor:pointer"
          bubble-owner="preset"
          :profile="profile"
          :message="aPreset.text"
          @click="handlePresetClick(aPreset)"
      />
    </div>
  </div>
</template>
<script>

import Bubble from "@/components/common/bubble";
import ThinkingDots from "@/components/common/typewriterText";
export default {
  name: "Sessions_Chat_Messages",
  components: {
    Bubble,
    ThinkingDots,
  },
  props: {
    profile: {
      type: Object,
      default: null,
      required: false
    },
    messageBoxRefId: {
      type: String,
      required: true
    },
    messages: {
      type: Array,
      default: ()=>{return []},
      required: false
    }
  },
  created() {

  },
  mounted() {},
  computed: {},
  methods: {
    scrollToBottom() {
      if (this.messagesBox) {
        this.messagesBox.scrollTop = this.messagesBox.scrollHeight + this.sidebarFooterHeight;
      }
    },
    handleIsThumbUp(message){
      //Update Message with Status
    },
    handlePresetClick(bubblePreset) {
      this.text = bubblePreset && bubblePreset.text ? bubblePreset : 'Enter your own text, please';
    },
    handleThumbClick(isThumbUp){

    },
    handleScroll(event){
      //alert(JSON.stringify(event));
    }
  },
  data() {
    return {
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 40,
        height: 40,
        class: "m1"
      },
      bubblePresets:[
        {
          text:"How can I upgrade my account to the solid plan?",
          _created_at:1234
        },
        {
          text:"How can I join a dementia caregiving support group?",
          _created_at:1234
        },
        {
          text:"How can I get tested for dementia?",
          _created_at:1234
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
